import React from 'react';
import { Scissors } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="border-t border-white/5 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg bg-primary/10 border border-primary/20 flex items-center justify-center">
              <Scissors className="w-4 h-4 text-primary" />
            </div>
            <span className="font-heading text-sm font-bold text-white italic">
              Golden Scissors.
            </span>
          </div>
          <p className="text-zinc-500 text-xs sm:text-sm">
            &copy; {new Date().getFullYear()} Golden Scissors. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
